import { Predicate } from '../../types/Predicate';

/**
 * Compose predicate functions with OR.
 */
export function or<T>(...predicates: Array<Predicate<T>>): Predicate<T> {
    return (value: T) => predicates.some((predicate) => predicate(value));
}
